var map = {
	"./app-menu-keys.js": 234,
	"./legacy-sites.js": 235,
	"./micro-frontend-sites.js": 236,
	"./nb-NO.js": 237,
	"./products.js": 238,
	"./routes.js": 126,
	"./screens.js": 37,
	"./sites.js": 25,
	"./tbs-links.js": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;